import React from 'react'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Toaster = () => {
    const contextClass = {
        success: `bg-slate-900 text-white border-lime-500/15`,
        error: "pt-2 bg-red-700 border border-red-950/15",
        info: "pt-2 bg-slate-900 border border-slate-500/15",
        warning: "pt-2 bg-slate-900  border border-slate-500/15",
        default: "bg-indigo-600",
        dark: "pt-2 bg-white-600 font-gray-300",
    };


    return (
        <div>
            <ToastContainer
                // autoClose={6000}
                toastClassName={({ type }) => contextClass[type || "success"] +
                    " flex items-center justify-center alata text-[0.8rem] text-center relative flex items-center pt-[1.25rem] pb-[1.75rem] mx-auto xs:mb-4 xl:mb-3 rounded-[6px] justify-between overflow-hidden cursor-pointer xs:w-[18rem] xsp:w-[20rem] md:w-[20%] lg:w-[20rem] 2xl:w-[22rem]"
                }
                progressClassName={`bg-gradient-to-b from-primaryRichBlue to-primaryRichGreen text-white/90 border-lime-500/15`}

            />
        </div>
    )
}

export default Toaster